import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const ChevronRight: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M7.20788 16.6667C6.79551 16.6667 6.5206 16.5293 6.24568 16.2543C5.69586 15.7045 5.69586 14.8798 6.24568 14.3299L10.6443 9.93131L6.24568 5.67014C5.69586 5.12032 5.69586 4.29557 6.24568 3.74575C6.79551 3.19592 7.62025 3.19592 8.17008 3.74575L13.5309 9.10657C13.8058 9.38148 13.9433 9.6564 13.9433 10.0688C13.9433 10.4811 13.8058 10.7561 13.5309 11.031L8.17008 16.2543C7.89517 16.5293 7.62025 16.6667 7.20788 16.6667Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default ChevronRight;